export default {
    'name': 'copy',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<g clip-path=\'url(#clip0_7492_119319)\'><path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M8.25 3C7.83579 3 7.5 3.33579 7.5 3.75V7.5H3.75C3.33579 7.5 3 7.83579 3 8.25V20.25C3 20.6642 3.33579 21 3.75 21H15.75C16.1642 21 16.5 20.6642 16.5 20.25V16.5H20.25C20.6642 16.5 21 16.1642 21 15.75V3.75C21 3.33579 20.6642 3 20.25 3H8.25ZM16.5 15H19.5V4.5H9V7.5H15.75C16.1642 7.5 16.5 7.83579 16.5 8.25V15ZM8.25 9H4.5V19.5H15V15.75V9H8.25Z\' fill=\'#026958\'/></g><defs><clipPath id=\'clip0_7492_119319\'><rect width=\'24\' height=\'24\' fill=\'white\'/></clipPath></defs>'
}
